/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Start_Translation_JobsInputs */



/**
* | output |
* | --- |
* | "Failed to start translation jobs. Please try again later." |
*
* @param {Failed_To_Start_Translation_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const failed_to_start_translation_jobs = /** @type {((inputs?: Failed_To_Start_Translation_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Start_Translation_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec du démarrage des tâches de traduction. Veuillez réessayer plus tard.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungsaufträge konnten nicht gestartet werden. Bitte versuchen Sie es später erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile avviare i lavori di traduzione. Riprova più tardi.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось запустить задания на перевод. Пожалуйста, попробуйте позже.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudieron iniciar los trabajos de traducción. Inténtelo de nuevo más tarde.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译任务启动失败，请稍后再试。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳ジョブを開始できませんでした。しばらくしてからもう一度お試しください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद कार्य प्रारंभ करने में विफलता। कृपया बाद में पुनः प्रयास करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível iniciar as tarefas de tradução. Tente novamente mais tarde.")
	return /** @type {LocalizedString} */ ("Failed to start translation jobs. Please try again later.")
});